import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';

import { CompanyIcon } from '@/components/CompanyIcon';

interface Props {
  websiteUrl: string | null | undefined;
  tickerSymbol: string;
  name: string;
  canonicalURL: string;
}

export const CompanyNameWithIcon = ({
  canonicalURL,
  websiteUrl,
  tickerSymbol,
  name,
}: Props) => {
  const { trackEvent } = useTracking();

  return (
    <RouterLink
      noUnderline
      to={canonicalURL}
      onClick={() => {
        trackEvent({
          action: 'click',
          canonicalURL,
        });
      }}
    >
      <div className="grid grid-cols-[max-content_auto] gap-x1">
        <CompanyIcon
          website={websiteUrl}
          tickerSymbol={tickerSymbol}
          size={40}
        />
        <div className="grid gap-0.5">
          <h2 className="m-0 text-xs text-brand-01 font-strong">
            {tickerSymbol}
          </h2>
          <div className="text-tiny text-softer line-clamp-1">{name}</div>
        </div>
      </div>
    </RouterLink>
  );
};
